MAP:
<canvas #canvas id="canvas" style="width: 600px; height: 400px;">
</canvas>
<div>
  @for (l of Levels; track l; let i = $index) {
    <button (click)="ShowLevel(i)">{{i}}</button>
  }
</div>